import { IonContent } from '@ionic/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography/index.ts';
import { DIALOGUE_SUPPORT_EMAIL, S3_BUCKET_URL } from '@/constants';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useDominateLayoutSelections } from '@/pages/Onboarding/hooks/useDominateLayoutSelections';
import { canLogEvents } from '@/utils/canLogEvents';
import { generateDownloadLink } from '@/utils/generateDownloadLink';

import { StoresLinks, SuccessPageDominateStyles } from './Domination.styles.ts';

const DominateVariant: React.FC = () => {
  const { user } = useAccount();
  // const [authToken, setAuthToken] = React.useState<string | null>(null);
  const { dominatrix_visual_style, tools } = useDominateLayoutSelections();
  const notes = webCampaign.setup.paywallNotes;

  // React.useEffect(() => {
  //   const fetchAuthToken = async () => {
  //     const auth = await apiV1GetMeAuthRequest();
  //     setAuthToken(auth.token);
  //   };
  //   fetchAuthToken();
  // }, []);

  const getBackgroundSrc = () => {
    if (notes?.includes('jia')) {
      return `${S3_BUCKET_URL}/success-page/default/dominate/jia/congrats.png`;
    }

    if (notes?.includes('lucy')) {
      return `${S3_BUCKET_URL}/success-page/default/dominate/lucy/congrats.png`;
    }

    return `${S3_BUCKET_URL}/paywall/v5-dominate/${dominatrix_visual_style}_${tools}.png`;
  };

  const downloadingAppLink = React.useMemo(() => {
    return generateDownloadLink(user?.id || '');
  }, [user?.id]);

  const fireAmplitude = (storeType: string) => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('download_click', {
        type: storeType,
      });
    }
  };

  return (
    <SuccessPageDominateStyles
      background={webCampaign.getStaticTheme()}
      backgroundImage={getBackgroundSrc()}
    >
      <IonContent>
        <div className={'image-container'} />
        <div className="content">
          <OnboardingTitle className="success-payment-title">
            Congrats, your purchase
            <br /> was successful!
          </OnboardingTitle>
          <div className="next-actions">
            <UiTypography
              align="center"
              variant="body-large"
              className="next-action-description"
            >
              Choose the platform
            </UiTypography>
            <StoresLinks>
              <a
                href={downloadingAppLink}
                onClick={() => fireAmplitude('appstore')}
              >
                <img
                  src={`${S3_BUCKET_URL}/onboarding/appstore.png`}
                  alt="appstore"
                />
              </a>
              <a
                href={downloadingAppLink}
                onClick={() => fireAmplitude('googleplay')}
              >
                <img
                  src={`${S3_BUCKET_URL}/onboarding/googleplay.png`}
                  alt="googleplay"
                />
              </a>
            </StoresLinks>

            {/* {webCampaign.setup.hasWebAppLink && !!authToken && (
              <WebVersionLink>
                <a href={`${WEB_APP_URL}/?auth=${authToken}`} target="_blank">
                  <IonIcon icon={globeOutline} />
                  <UiTypography variant="label-large" color="white">
                    Web version
                  </UiTypography>
                </a>
              </WebVersionLink>
            )} */}

            <UiTypography variant="body-large" align="center">
              OR download the app via the link we sent to your email,{' '}
              {user?.email} (check Inbox and Spam).
            </UiTypography>
          </div>
          <UiTypography
            variant="body-medium"
            className="questions-email"
            align="center"
          >
            If you have any questions - reach us at{' '}
            <a href={`mailto:${DIALOGUE_SUPPORT_EMAIL}`} target="_blank">
              {DIALOGUE_SUPPORT_EMAIL}
            </a>
          </UiTypography>
        </div>
      </IonContent>
    </SuccessPageDominateStyles>
  );
};

export default DominateVariant;
